import {
  ShimmerButton,
  ShimmerSimpleGallery,
} from "react-shimmer-effects";

const FunnelLeakageLoading = () => {
  return (
    <div
      className="min-h-[330px] rounded-lg bg-gray-100 shadow-lg p-3"
      style={{ width: "79%" }}
    >
      <div>
        <div className="flex gap-5">
          <div className="grow grow-col relative">
            <div className="bg-white w-full">
              <div className="p-5 w-full h-96"></div>
            </div>
            <div className="absolute left-0 top-0 p-4 mb-5">
              <ShimmerButton size="lg" />
            </div>
            <div className="absolute left-0 top-10 p-4">
              <ShimmerSimpleGallery
                className="mb-0 w-96 mt-10 ms-32"
                row={1}
                col={1}
                imageType={"thumbnail"}
                imageHeight={200}
                gap={30}
              />
            </div>

            <div className="absolute top-3 right-60 p-4 grid grid-cols-2 gap-3">
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
              <ShimmerButton size="lg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunnelLeakageLoading;
